import React from 'react';
import { PictureOutlined } from '@ant-design/icons';
import { CardSelector } from '../shared/card-selector';
import { useEditorContext } from '../../context/editor-context';
import { getAllAmbientes, getAmbientePreviewAny } from '../../utils/avatar-lookups';
import { capitalize } from '../../../../utils/capitalze';

/**
 * Background/Ambiente section — primer nivel del selector encadenado.
 * Muestra todos los ambientes disponibles.
 * Al cambiar ambiente se resetean vestuario y plano.
 */
export const BackgroundSection: React.FC = () => {
  const { scene, activeIndex, updateScene } = useEditorContext();

  const ambientes = getAllAmbientes();

  const options = ambientes.map(a => ({
    id: a,
    label: capitalize(a),
    imageUrl: getAmbientePreviewAny(a)
  }));

  const handleChange = (id: string) => {
    if (id !== scene.ambiente) {
      updateScene(activeIndex, 'vestuario', '');
      updateScene(activeIndex, 'plano', 'medio');
    }
    updateScene(activeIndex, 'ambiente', id);
  };

  return (
    <CardSelector
      label='Entorno'
      icon={<PictureOutlined />}
      options={options}
      value={scene.ambiente}
      onChange={handleChange}
    />
  );
};
